import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Review } from '../../interfaces/review';

@Component({
  selector: 'app-review-card',
  templateUrl: './review-card.component.html',
  styleUrls: ['./review-card.component.css'],
})
export class ReviewCardComponent implements OnInit {
  @Input() review!: Review;

  @Output() onApprove = new EventEmitter<string>();
  @Output() onDecline = new EventEmitter<string>();
  @Output() onDelete = new EventEmitter<string>();
  @Output() onSaveReply = new EventEmitter<{ id: string; reply: string }>();
  @Output() onDeleteReply = new EventEmitter<string>();
  @Output() onToggleHide = new EventEmitter<string>();
  starsArray = [1, 2, 3, 4, 5];
  isReplying = false;
  isEditing = false;
  replyText = '';

  ngOnInit(): void {}

  approve(): void {
    this.onApprove.emit(this.review.id);
  }
  decline(): void {
    this.onDecline.emit(this.review.id);
  }

  deleteReply(): void {
    this.onDeleteReply.emit(this.review.id);
  }
  toggleHide(): void {
    this.onToggleHide.emit(this.review.id);
  }

  toggleReply(): void {
    if (this.review.storeReply) return; // already replied — use edit pencil
    this.isReplying = true;
    this.replyText = '';
  }

  startEdit(): void {
    this.isEditing = true;
    this.isReplying = false;
    this.replyText = this.review.storeReply || '';
  }

  cancelReply(): void {
    this.isReplying = false;
    this.isEditing = false;
    this.replyText = '';
  }

  sendReply(): void {
    if (!this.replyText.trim()) return;
    this.onSaveReply.emit({ id: this.review.id, reply: this.replyText.trim() });
    this.isReplying = false;
    this.isEditing = false;
    this.replyText = '';
  }
  showDeleteConfirm = false;

  deleteReview(): void {
    this.showDeleteConfirm = true;
  }

  confirmDelete(): void {
    this.showDeleteConfirm = false;
    this.onDelete.emit(this.review.id);
  }

  cancelDelete(): void {
    this.showDeleteConfirm = false;
  }
}
